<template>
	<button class="mgs-button button is-link" v-on="$listeners">
        <slot />
    </button>
</template>
<script>
export default {
	name: 'BaseButton',
	props: {},
	methods: {}
}
</script>
<style scoped>
.mgs-button:disabled {
	cursor: no-drop;
}

</style>
